export const ProcessModel = {
    path: '/boarding_process_models',
    name: 'boarding_process_models',
    component: () => import('@/views/Boarding/ProcessModel/ProcessModelPage.vue'),
    children: [
        {
            path: '/boarding_process_models/add',
            name: 'boarding_process_models.add',
            component: () => import('@/views/Boarding/ProcessModel/Form/ProcessModelForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/boarding_process_models/edit/:id',
            name: 'boarding_process_models.edit',
            component: () => import('@/views/Boarding/ProcessModel/Form/ProcessModelForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/boarding_process_models/delete/:id',
            name: 'boarding_process_models.delete',
            component: () => import('@/views/Boarding/ProcessModel/Form/ProcessModelForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/boarding_process_models/view/:id',
            name: 'boarding_process_models.view',
            component: () => import('@/views/Boarding/ProcessModel/Form/ProcessModelForm.vue'),
            props: {viewAction: true}
        },
    ],
}